<template>
  <v-container>
    <v-row class="menu mx-auto" style="max-width: 600px">
      <v-col md="4" sm="6" v-for="item in display" :key="item.guid">
        <router-link :to="menuTo(item)" class="menu__item pa-3">
          <div class="menu__item-top">
            <div v-if="item.image" class="menu__item-image mx-auto" :class="item.image"></div>
            <span v-if="item.icon" class="menu__item-logo d-block mb-3" :class="item.icon"></span>
            <p class="menu__item-title mb-0">{{ title(item) }}</p>
            <p class="menu__item-desc">{{ subtitle(item) }}</p>
          </div>

          <div class="menu__item-bottom">
            <span class="menu__item-more-btn grey lighten-1 ml-auto">
              <v-icon color="white" size="20">mdi-chevron-right</v-icon>
            </span>
          </div>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lang from '@/lang';

export default {
  name: 'app-home-menu',
  props: {
    menu: Array,
  },
  computed: {
    display() {
      return this.menu
        .filter(p => !p.menu.parentId && p.menu.url !== ':permission')
        .map(p => p.menu)
        .sort((a, b) => (a.order > b.order ? 1 : -1));
    },
  },
  mounted() {
    this.redirect();
  },
  methods: {
    menuTo(item) {
      const hasURL = !!item.url;

      return {
        name: hasURL ? 'menu.display' : 'menu.child',
        params: { id: item.guid, url: item.url },
      };
    },
    title(item) {
      return {
        en: item.titleEN,
        fr: item.titleFR,
      }[lang.locale] || item.titleEN;
    },
    subtitle(item) {
      return {
        en: item.subtitleEN,
        fr: item.subtitleFR,
      }[lang.locale] || item.subtitleEN;
    },
    redirect() {
      if (this.display.length === 1) {
        this.$router.push(this.menuTo(this.display[0]));
      }
    },
  },
};
</script>
